var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":_vm.color,"type":_vm.type,"width":_vm.width,"height":_vm.height,"disabled":_vm.isDisabled,"depressed":_vm.isDepressed},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }